<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="650px" persistent>
      <v-card :loading="!!nowProcessingBidWithId" :disabled="!!nowProcessingBidWithId">
        <v-card-actions>
          <h3 class="pl-2" id="bidWindow">
            {{ $t("viewBids.bid") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4" v-if="tmpBid.is_deleted">
            <v-alert type="warning" outlined dense>
              {{ $t("viewBids.bid_is_deleted") }}
            </v-alert>
          <v-card-actions class="pa-0 mx-0">
            <v-spacer></v-spacer>
            <v-btn
                :loading="savingInProgress"
                class="mt-5"
                color="warning"
                @click="restore"
                @keyup.enter="restore"
                elevation="0"
            >
              {{ $t("common.restore") }}
            </v-btn>
            <v-btn
                :loading="savingInProgress"
                class="mt-5"
                color="primary"
                @click="showWindow = false"
                @keyup.enter="showWindow = false"
                elevation="0"
            >
              {{ $t("common.close") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
        <v-card-text class="pa-4" v-else>
          <v-form ref="bidForm">
            <template v-if="!customer">
              <v-text-field
                outlined
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                :value="tmpBid.customer_name"
                v-model="tmpBid.customer_name"
                :label="$t('common.customer')"
              ></v-text-field>
              <v-text-field
                outlined
                :rules="[
                  (v) => !!v || $t('form.validationErrors.field_is_required'),
                ]"
                :value="tmpBid.customer_phone"
                v-model="tmpBid.customer_phone"
                :label="$t('common.phone')"
              ></v-text-field>
            </template>
            <template v-if="customer">
              <span class="text-caption">{{ $t("common.customer") }}:</span>
              <h4 class="pb-2">{{ customer.full_name }}</h4>
            </template>
            <bid-stage-select
                :outlined="true"
                v-if="bidId"
                :bid-stages="bidStages"
                :stage="tmpBid.stage"
                :loading="
                !!nowProcessingBidWithId || !bidsStagesIsFetched
              "
                @update="
                (st) => {
                  tmpBid.stage = st;
                  tmpBid.bid_stage_id = st.id;
                }
              "
            ></bid-stage-select>
            <span class="text-caption">{{ $t("viewBids.desired_date") }}:</span>
<!--            todayDate={{ todayDate }}; locale={{locale}}-->
<!--            bidDate={{bidDate}}-->
            <date-time-picker
              class="mt-2 d-block"
              outlined
              :date-label="$t('viewCalendar.start_date')"
              :time-label="$t('viewCalendar.start_time')"
              :date.sync="bidDate"
              :time.sync="bidTime"
              :min-date="todayDate"
              :min-time="undefined"
            />
            <v-textarea
              hide-details
              class="mt-5"
              outlined
              :label="$t('common.comment')"
              v-model="tmpBid.comment"
            ></v-textarea>

              <v-list disabled v-if="bid.operations" class="pa-0 ma-0">
                <v-subheader>{{$t('viewBids.desired_operations')}}</v-subheader>
                <v-list-item-group
                    color="primary"
                >
                  <v-list-item
                      v-for="(item, i) in bid.operations"
                      :key="i"
                  >
                    <v-list-item-icon>
                      <v-icon small>$works</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ getOperationName(item, lang) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions class="pa-0 mx-0">
              <v-spacer></v-spacer>
              <v-btn
                :loading="savingInProgress"
                class="mt-5"
                color="primary"
                @click="submit"
                @keyup.enter="submit"
                elevation="0"
              >
                {{ $t("common.save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import BidsMixin from "@/mixins/bids";
import CommonMixin from "@/mixins/common";
import CalendarMixin from "@/mixins/calendar";
import BeautyCarNumber from "../common/BeautyCarNumber";
import DateTimePicker from "@/components/common/DateTimePicker";
import BidStageSelect from "./BidStageSelect";

export default {
  name: "BidWindow",
  components: {BidStageSelect, BeautyCarNumber, DateTimePicker },
  mixins: [CommonMixin, CalendarMixin, BidsMixin],
  props: {
    newCustomerPhoneNumber: null,
    show: {
      type: Boolean,
      default: false,
    },
    bidId: {
      type: Number,
      default: null,
    },
    customer: null,
  },
  data: () => ({
    todayDate: null,
    tmpBid: {
      customer_name: null,
      customer_phone: null,
      desired_date: null,
      comment: null,
      customer_id: null,
      is_deleted: null,
    },
  }),
  methods: {
    /**
     * Восстановление удаленной заявки
     */
    restore() {
      this.$store.dispatch("bids/restore", this.tmpBid).then((bid) => {
        this.tmpBid = bid;
      });
    },
    submit() {
      if (!this.$refs.bidForm.validate()) return;
      if (!this.bidId) {
        this.$store.dispatch("bids/store", this.tmpBid).then((createdBid) => {
          if (createdBid.id > 0) {
            this.$emit("store", createdBid);
            this.$emit("hide");
          }
        });
      } else {
        this.$store.dispatch("bids/update", this.tmpBid).then((bid) => {
          if (bid.id > 0) {
            this.$emit("update", bid);
            this.$emit("hide");
          }
        });
      }
    },
    setTodayDate(){
      let today = new Date();

      let day = today.getDate()<10 ? '0'+String(today.getDate()) : today.getDate();

      this.todayDate = `${today.getFullYear()}-${
          today.getMonth() + 1 < 10 ? 0 : ""
      }${today.getMonth() + 1}-${day}`;
    }
  },
  computed: {
    ...mapFields("bids", ["savingInProgress", "nowProcessingBidWithId", "bid"]),
    ...mapFields("bid_stages", ["bidStages"]),
    ...mapFields("bid_stages", { bidsStagesIsFetched: "fetched" }),
    ...mapFields("site", ['lang']),
    bidDate: {
      get() {
        if (this.tmpBid.desired_date) {
          return this.tmpBid.desired_date.substring(0, 10);
        }
        return null;
      },
      set(date) {
        if(!date) return;
        if (!this.bidTime) {
          this.tmpBid.desired_date = date + " " + "11:00";
        } else {
          this.tmpBid.desired_date = date + " " + this.bidTime;
        }
      },
    },
    bidTime: {
      get() {
        if (this.tmpBid.desired_date) {
          return this.tmpBid.desired_date.substring(11);
        }
        return null;
      },
      set(time) {
        if(!time) return;
        if (!this.bidDate) this.tmpBid.desired_date = this.todayDate;
        this.tmpBid.desired_date = this.bidDate + " " + time;
      },
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$refs["bidForm"] && this.$refs["bidForm"].resetValidation();
        this.$emit("hide");
      },
    },
  },
  mounted() {
  },

  watch: {
    show(to) {
      this.setTodayDate();
      if (to) {
        if (!this.bidId) {
          this.tmpBid.customer_phone = this.newCustomerPhoneNumber
            ? this.newCustomerPhoneNumber
            : null;
          this.tmpBid.desired_date = null;
          this.tmpBid.comment = null;
          this.tmpBid.customer_id = null;
          if (this.customer) {
            this.tmpBid.customer_id = this.customer.id;
          }
        } else {
          //получение
          this.$store.dispatch('bids/getBid', this.bidId).then(()=>{
            this.tmpBid = this.bid
          })
        }
      }
      if(!this.bidStages.length){
        this.$store.dispatch("bid_stages/get");
      }
    },
  },
};
</script>
